<template>
  <footer class="page-footer" role="contentinfo">
    <div class="page-footer__inner">
      <div class="inner__left">
        <div v-if="!isLoggedIn" class="share-buttons" v-cloak>
          <div class="sharethis-inline-share-buttons"></div>
        </div>
      </div>

      <div class="inner__middle">
        &copy; Copyright 2016-{{ copyrightYearEnd }} Energy PriceBook. &nbsp; <span class="text-nowrap">All Rights Reserved.</span> &nbsp; <span class="text-nowrap">Patent No.: 11,410,190</span>

        <template v-if="!isLoggedIn" v-cloak>
          <br>
          <a href="/terms-of-use/user-agreement">Terms of Use</a>
        </template>
      </div>

      <div class="inner__right"></div>
    </div><!--/.page-footer__inner-->
  </footer>
</template>

<script>
export default {
  computed: {
    copyrightYearEnd() {
      return new Date().getFullYear().toString().substr(-2)
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
  }
}
</script>
